var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileSolid = function SvgFileSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M15.625 2.5h-2.833a3.744 3.744 0 0 0-5.584 0H4.375a1.25 1.25 0 0 0-1.25 1.25v13.125a1.25 1.25 0 0 0 1.25 1.25h11.25a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25M10 2.5A2.5 2.5 0 0 1 12.5 5h-5A2.5 2.5 0 0 1 10 2.5m2.5 10h-5a.625.625 0 1 1 0-1.25h5a.625.625 0 0 1 0 1.25m0-2.5h-5a.625.625 0 1 1 0-1.25h5a.625.625 0 1 1 0 1.25"
  })));
};
export default SvgFileSolid;